import { chunk } from "../helpers/functions"

function customersPage(init) {
  const context = {}
  const btnText = $(".btn-more .btn").html()
  const isMobile = $("#is-mobile").val()
  let total = 0
  context.page = 1
  context.list = new Proxy([], {
    set(array, property, value, receive) {
      context.render([...array])
      if (array.length >= total) {
        $(".btn-more").hide()
      } else {
        $(".btn-more").show()
      }
      return Reflect.set(...arguments)
    },
  })
  context.start = () => {
    context.page = 1
    $.ajax({
      type: "get",
      url: window.toUrl
        .replace("__ACTION__", "contents-meta")
        .replace("__PAGE__", 1)
        .replace("__SIZE__", 0),
      dataType: "json",
      success(count) {
        total = parseInt(count)
        context.fetchCategories()
      },
      error(xhr, ajaxOptions, thrownError) {
        console.log(
          "There was a problem loading that page. You may need to refresh.",
        )
      },
    })
  }
  context.fetchCategories = () => {
    $.ajax({
      type: "get",
      url: window.toUrl
        .replace("__ACTION__", "contents")
        .replace("__PAGE__", context.page)
        .replace("__SIZE__", 18),
      dataType: "json",
      beforeSend() {
        $(".btn-more .btn").html(
          '<span class="fas fa-spinner fa-spin"></span> Loading...',
        )
      },
      success(response) {
        response.forEach((item) => {
          context.list.push(item)
        })
        context.page++
      },
      error(xhr, ajaxOptions, thrownError) {
        console.log(
          "There was a problem loading that page. You may need to refresh.",
        )
      },
      complete() {
        $(".btn-more .btn").html(btnText)
      },
    })
  }
  context.render = (list) => {
    if (list.length > 0) {
      const chunks = chunk(list, isMobile ? 2 : 6)
      const t = `
        ${chunks
          .map(
            (chunk) => `
            <div class="row">
                ${chunk
                  .map(
                    (content) => `
                    <div class="col-6 col-md-2 item-col">
                        ${context.contentTemplate(content)}
                    </div>
                `,
                  )
                  .join("")}
            </div>
            <div class="details">
                ${chunk
                  .map(
                    (content) => `${context.contentDetailsTemplate(content)}`,
                  )
                  .join("")}
            </div>
        `,
          )
          .join("")}
      `
      $(".posts").html(t)
      context.calculateHeights()
    } else {
      $(".posts").empty()
    }
  }

  context.contentTemplate = (content) => {
    return `
        <a href="${content.url}" data-id="content-${
      content.id
    }" class="item" style="--image:url('${
      content.home_customer_logo?.url || null
    }');">
            <div class="info">
                <h2 class="title">${content.local.title}</h2>
            </div>
        </a>
    `
  }

  context.contentDetailsTemplate = (content) => {
    return `
        <div class="customer-box" id="content-${content.id}">
            <div class="section-title">${content.local.title}</div>
            <div class="text rich-text">${content.local.text}</div>
        </div>
      `
  }

  context.calculateHeights = () => {
    $(".posts .details").each(function (i, details) {
      let max = 0
      $(details)
        .find(".customer-box")
        .each(function (j, box) {
          $(box).css("--height", $(this).height() + "px")
          if (max < $(this).height()) {
            max = $(this).height()
          }
        })
      $(details).css("--height", max + "px")
    })
  }

  $(".posts").on("click", "a.item", function (e) {
    e.preventDefault()
    const id = $(this).data("id")
    if ($(this).hasClass("active")) {
      $(this).removeClass("active")
      $(`.posts .details .customer-box#${id}`).removeClass("active")
      $(".posts .details.active").removeClass("active")
    } else {
      $(".posts .item.active").removeClass("active")
      $(this).addClass("active")
      $(".posts .details.active").removeClass("active")
      $(".posts .details .customer-box.active").removeClass("active")
      $(`.posts .details .customer-box#${id}`).addClass("active")
      $(`.posts .details .customer-box#${id}`).parent().addClass("active")
    }
  })

  $(".btn-more").on("click", context.fetchCategories)

  init(context)
}

window.customersPage = customersPage
